<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/dingdan.png" class="jxyd-imgicon" />
				操作销售订单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>
					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							客户
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.customerId" filterable clearable
								@on-change="getCustomerDiscount" style="width:70%;">
								<Option v-for="item in customerList" placeholder="请选择客户" :value="item.id"
									:key="item.id">
									{{item.name}}
								</Option>
							</Select>
							<label class="discount-label">{{'(折扣：'+documentItem.customerDiscount+'%)'}}</label>
						</td>
					</tr>
					<tr>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.commoditySelected = data;}" :selectedCommodity="commoditySelected"
							:type='"3"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="commoditySelected"
							@submitSelected='data=>{this.commoditySelected = data;}' @onInputVal='onInputVal'
							:type='"3"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.salesPlanDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">本单金额：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.originalPrice}}</span>
						</td>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">折后金额：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.amount}}</span>
						</td>
						<td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">定金：
						</td>
						<td>
							<SelectTradeMethod :value.sync='documentItem.payWay' :accountPid='accountPid'>
							</SelectTradeMethod>
						</td>
						<td style="padding-left: 5px;">
							<InputNumber v-model="documentItem.deposit" :min="0" placeholder="定金"
								@on-change="!documentItem.deposit ? documentItem.deposit = 0 : documentItem.deposit = documentItem.deposit">
							</InputNumber>
						</td>
					</tr>
				</table>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectTradeMethod from '@/components/SelectTradeMethod'
	import DocumentFile from '@/components/DocumentFile'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'salesplanlistfunc',
		mixins: [printMixin],
		components: {
			SelectCommodityModal,
			SelectTradeMethod,
			DocumentFile,
			SelectCommodityByCodeModal
		},
		computed: {
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.salesPlanDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: null,
								unit: item.unit,
								discount: item.discount,
								price: item.price,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: null,
								unit: item.unit,
								discount: item.discount,
								price: item.price,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.addDetailInfo(newValue);
				}
			}
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					originalPrice: 0,
					amount: 0,
					deposit: 0,
					salesPlanDetailList: [],
					customerId: '',
					customerName: '',
					customerDiscount: '100',
					customerPriceGrade: 'retailPrice',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.salesPlanDetailList.splice(params.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 345,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.documentItem.salesPlanDetailList[params.index].unit =
												event;
											this.unitChange(params.index);
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 140,
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity
								},
								on: {
									input: (e) => {
										this.documentItem.salesPlanDetailList[params.index]
											.quantity = e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.salesPlanDetailList[
													params.index].quantity = 0;
											}
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.salesPlanDetailList[
														params.index].price * (this
														.documentItem
														.salesPlanDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`amount`, formatNum(this.documentItem
													.salesPlanDetailList[params.index]
													.quantity * this.documentItem
													.salesPlanDetailList[params.index]
													.priceAfterDiscount));
										});
									}
								}
							})]
						}
					},
					{
						title: '单价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.price
								},
								on: {
									input: (e) => {
										this.documentItem.salesPlanDetailList[params.index].price =
											e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.salesPlanDetailList[
													params.index].price = 0;
											} else if (e < 0) {
												this.documentItem.salesPlanDetailList[
													params.index].price = 0;
											}
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.salesPlanDetailList[
														params.index].price * (this
														.documentItem
														.salesPlanDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`amount`, formatNum(this.documentItem
													.salesPlanDetailList[params.index]
													.quantity * this.documentItem
													.salesPlanDetailList[params.index]
													.priceAfterDiscount));
										})
									}
								}
							})]
						}
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'max': 100,
									'value': params.row.discount
								},
								on: {
									input: (e) => {
										this.documentItem.salesPlanDetailList[params.index]
											.discount = e;
										this.$nextTick(function() {
											if (e == null) {
												this.documentItem.salesPlanDetailList[
													params.index].discount = 100;
											} else if (e < 0) {
												this.documentItem.salesPlanDetailList[
													params.index].discount = 100;
											}
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`priceAfterDiscount`, formatNum(this
													.documentItem.salesPlanDetailList[
														params.index].price * (this
														.documentItem
														.salesPlanDetailList[params
															.index].discount / 100)));
											this.$set(this.documentItem
												.salesPlanDetailList[params.index],
												`amount`, formatNum(this.documentItem
													.salesPlanDetailList[params.index]
													.quantity * this.documentItem
													.salesPlanDetailList[params.index]
													.priceAfterDiscount));
										})
									}
								}
							})]
						}
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 350,
					}
				],
				userList: [],
				customerList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				accountPid: 'sfkzh'
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.amount = 0;
				this.documentItem.originalPrice = 0;
				this.documentItem.salesPlanDetailList = [];
				this.documentItem.customerId = '';
				this.documentItem.customerName = '';
				this.documentItem.customerDiscount = '0';
				this.documentItem.customerPriceGrade = 'retailPrice'
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userName = localStorage.getItem("userName");
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.payWay = '';
				this.documentItem.checkState = 1;
				this.documentItem.deposit = 0;
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.salesPlanDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.salesPlanDetailList[index].format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.salesPlanDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.salesPlanDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				return formatNum(stock);
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (!this.documentItem.customerId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择客户"
					});
					return false;
				}
				if (this.documentItem.amount <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}

				if (this.documentItem.deposit > this.documentItem.amount) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "定金不得大于总金额"
					});
					return false;
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/SalesPlanList/EditSalesPlanList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录销售订单操作
					var log = {
						FlowId: response.data,
						Title: '销售订单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此销售订单' : '创建了此销售订单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}

					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});


				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/SalesPlanList/EditSalesPlanList';
				} else {
					path = '/api/SalesPlanList/AddSalesPlanList';
				}
				request.post(path, self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录销售订单操作
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '销售订单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此销售订单' : '创建了此销售订单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkSalesPlanList(self.documentItem, '销售订单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			addDetailInfo(newValue) {
				this.documentItem.salesPlanDetailList = []
				newValue.forEach(item => {
					item.data.forEach(item2 => {
						let detail = {
							commodityId: item.commodity.id,
							name: item.commodity.name,
							unit: item2.unit,
							format: item2.priceType,
							quantity: item2.quantity,
							price: item2.price,
							discount: item2.discount ? item2.discount : 100,
							priceAfterDiscount: 0,
							amount: 0,
							note: '',
							creator: parseInt(localStorage.getItem("userId")),
							commodityId: item.commodity.id,
							commodity: item.commodity
						};
						detail.price = item2.price ? item2.price : this.getCommodityTypePrice(detail);
						detail.priceAfterDiscount = formatNum(detail.price * (detail.discount / 100));
						detail.amount = formatNum(detail.quantity * detail
							.priceAfterDiscount);
						this.documentItem.salesPlanDetailList.push(detail);
					});
				});
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				// 解析价格类型
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = this.documentItem.customerPriceGrade ? currentPriceType[this
						.documentItem.customerPriceGrade
					] : currentPriceType.retailPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			unitChange(index) {
				this.documentItem.salesPlanDetailList[index].price = this.getCommodityTypePrice(this
					.documentItem.salesPlanDetailList[index]);

				this.documentItem.salesPlanDetailList[index]
					.priceAfterDiscount =
					formatNum(this.documentItem.salesPlanDetailList[index]
						.price *
						(this
							.documentItem.salesPlanDetailList[index].discount /
							100))

				this.documentItem.salesPlanDetailList[index].amount = formatNum(
					this.documentItem.salesPlanDetailList[index].quantity *
					this
					.documentItem.salesPlanDetailList[index]
					.priceAfterDiscount);
			},
			getNextCode() {
				let self = this;
				request.get('/api/SalesPlanList/GetNextCode', {
					params: {
						prefix: 'XDD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/SalesPlanList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "销售订单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录销售单操作
								log.push({
									FlowId: ids[i],
									Title: '销售订单日志',
									OperationContent: '回滚了此销售订单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getPlanList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkSalesPlanList(data, func) {
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/SalesPlanList/CheckSalesPlanList', [{
							id: data.id,
							state: 2
						}]).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							//记录销售单操作
							log.push({
								FlowId: data.id,
								Title: '销售订单日志',
								OperationContent: '审核了此销售订单',
								Operator: parseInt(localStorage.getItem("userId")),
								State: 1,
								Creator: parseInt(localStorage.getItem("userId"))
							});
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			getCustomerDiscount(val) {
				for (var i = 0; i < this.customerList.length; i++) {
					if (this.customerList[i].id == val) {
						this.documentItem.customerPriceGrade = this.customerList[i].priceGrade;
						this.documentItem.customerDiscount = this.customerList[i].discount;
						this.addDetailInfo(this.commoditySelected);
						break;
					}
				}
				this.countAmount();
			},
			countAmount() {
				const {
					documentItem
				} = this;
				const {
					salesPlanDetailList,
					customerDiscount
				} = documentItem;

				// 重置值
				documentItem.amount = 0;
				documentItem.originalPrice = 0;

				// 缓存长度避免重复访问
				const listLength = salesPlanDetailList.length;

				for (let i = 0; i < listLength; i++) {
					const currentDetail = salesPlanDetailList[i];
					const {
						commodity,
						unit,
						format,
						quantity,
						amount
					} = currentDetail;

					// 计算原始价格
					documentItem.originalPrice +=
						this.getCommodityTypePrice(salesPlanDetailList[i]) * quantity;

					// 累加金额
					documentItem.amount += amount;
				}

				// 格式化结果
				documentItem.originalPrice = formatNum(documentItem.originalPrice);
				documentItem.amount = formatNum(
					documentItem.amount * (customerDiscount / 100)
				);
			},

			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initCustomerSelect() {
				let self = this;
				request.get('/api/Customer/GetCustomerToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取客户数据失败：" + response.errorMsg
						});
						return;
					}
					self.customerList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['SalesPlanList.Add', 'SalesPlanList.Edit', 'SalesPlanList.Delete',
						'SalesPlanList.Audit', 'SalesPlanList.BatchAudit', 'SalesPlanList.Print',
						'SalesPlanList.Rollback', 'SalesPlanList.Export', 'SalesPlanList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'SalesPlanList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'SalesPlanList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'SalesPlanList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'SalesPlanList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'SalesPlanList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'SalesPlanList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'SalesPlanList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'SalesPlanList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'SalesPlanList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				// 准备打印数据（原 packPrintData 逻辑不变）
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'salesPlanList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}

				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));

				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};

				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}

					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});

					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});

					return totals;
				};

				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						// 处理 "2026-03-20 00:00:00" 或 "2026-03-20" 格式
						return dateStr.split(' ')[0];
					}
					return '';
				};

				// 格式化单条销售订单记录
				const formatSingle = (record) => {
					if (!record) return {};

					// 格式化商品明细（销售订单的商品列表）
					let commodityRaw = (record.salesPlanDetailList || []).map(item => ({
						name: item.name || '',
						format: item.format || '',
						unit: item.unit || '',
						quantity: safeNumber(item.quantity),
						price: safeNumber(item.price),
						discount: safeNumber(item.discount),
						amount: safeNumber(item.amount)
					}));

					// 添加序号
					let commodityDetail = addSerialNo(commodityRaw);

					// 添加合计行
					if (commodityRaw.length > 0) {
						const totals = calcTotals(commodityRaw, ['quantity', 'amount']);
						commodityDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							quantity: totals.quantity,
							price: '',
							discount: '',
							amount: totals.amount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						customerName: record.customerName || '',
						discount: safeNumber(record.customerDiscount) || 100,
						originalPrice: safeNumber(record.originalPrice),
						amount: safeNumber(record.amount),
						deposit: safeNumber(record.deposit),
						payWay: record.payWay || '',
						note: record.note || '',
						commodityDetail: commodityDetail
					};
				};

				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
			getPlanList(planListId) {
				let self = this;
				request.get('/api/SalesPlanList/GetSalesPlanList', {
					params: {
						id: planListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initPlanList(response.data);
				}).catch(function(error) {})
			},
			initPlanList(data) {
				this.documentItem = data;
			}
		},
		watch: {
			'documentItem.salesPlanDetailList': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			},
			'$route.query.planListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getPlanList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initCustomerSelect();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>